module.exports = __webpack_public_path__ + "img/shirt-01.bec46383.png";